import React from 'react'

import { NotificationsCardWrapper } from './NotificationsCardWrapper'
import { NotificationsDisclaimer } from './NotificationsDisclaimer'

export const ScheduleReminderSettings = (): JSX.Element => {
  return (
    <>
      <NotificationsCardWrapper />
      <NotificationsDisclaimer />
    </>
  )
}